<script setup>
import { useEventListener } from '@vueuse/core';
import LoginModal from 'module/loginModal/LoginModal.vue';
import AppSnackbar from 'module/snackbar/AppSnackbar.vue';
import TheFooter from 'module/footer/TheFooter.vue';
import { showSnackbar } from 'util/snackbar';
import { userNotifications } from 'app/userNotifications';
import { onBeforeMount } from 'vue';
import { REGEX_JOBSEARCH_CONTROLLER } from 'app/regularExpressions';
import { sendServerSideGa4Events } from 'util/googleAnalytics';
import NotificationBar from 'module/notificationBar/NotificationBar.vue';
import ClientOnly from '../../vue-components/ClientOnly.vue';
import { useLogin } from '../../composables/login';

defineProps({
    layout: { type: Object },
});

const emit = defineEmits(['getUserJobSearchRequest']);

let headerClientReady = false;

const { showLoginModal, setRedirectUrl, setMode } = useLogin();

function openLoginModal({ comingFromJobSearchPage = false, register = false, redirect = undefined } = {}) {
    const isJobSearch = new RegExp(REGEX_JOBSEARCH_CONTROLLER).test(window.location.pathname);

    if (isJobSearch && !comingFromJobSearchPage) {
        emit('getUserJobSearchRequest', register);
    } else {
        setMode(register ? 'register' : 'login');
        setRedirectUrl(redirect);
        showLoginModal();
    }
}

function onLoginButtonClick() {
    openLoginModal();
}

function onNavItemClick(e) {
    openLoginModal({
        redirect: e.detail.redirectUrl,
        comingFromJobSearchPage: true,
    });
}

function onRegisterLinkClick() {
    openLoginModal({
        register: true,
    });
}

/*
function hideContent() {
    // hideContent not implemented yet
    this.props.scrollPosition = window.pageYOffset;
    this.dom.headerContainer?.classList.add('l-master__headerContainer--hide');
    this.dom.headerSmallContainer?.classList.add('l-master__headerSmallContainer--hide');
    this.dom.content.classList.add('l-master__content--hide');
    this.dom.footer.classList.add('m-footer--hide');
}
*/

/*
function showContent() {
    // showContent not implemented yet
    this.dom.headerContainer?.classList.remove('l-master__headerContainer--hide');
    this.dom.headerSmallContainer?.classList.remove('l-master__headerSmallContainer--hide');
    this.dom.content.classList.remove('l-master__content--hide');
    this.dom.footer.classList.remove('m-footer--hide');
    if (this.props.scrollPosition) {
        window.scrollTo(0, this.props.scrollPosition);
    }
}
*/

/*
function hideFooter() {
    // hideFooter not implemented yet
    if (this.dom.smallFooter && !this.dom.smallFooter.classList.contains('m-smallFooter--hide')) {
        this.dom.smallFooter.classList.add('m-smallFooter--hide');
    }
}
*/

/*
function showFooter() {
    throw new Error('showFooter not implemented yet');

    if (this.dom.smallFooter && this.dom.smallFooter.classList.contains('m-smallFooter--hide')) {
        this.dom.smallFooter.classList.remove('m-smallFooter--hide');
    }
}
*/

onBeforeMount(async () => {
    const client = (await import('@karriereat/mf-header-client')).default;

    useEventListener(window, 'mf-header:click-loginButton', onLoginButtonClick);
    useEventListener(window, 'mf-header:click-registerLink', onRegisterLinkClick);
    useEventListener(window, 'mf-header:click-nav-item', onNavItemClick);

    function updateUserNotifications() {
        if (headerClientReady) {
            client.updateNotifications(userNotifications.notifications);
        }
    }

    userNotifications.events.on('update', updateUserNotifications);
    sendServerSideGa4Events();

    client.onReady(() => {
        headerClientReady = true;
        client.updateNotifications(userNotifications.notifications);
    });
});
</script>

<template>
    <div>
        <LoginModal
            @show-snackbar="showSnackbar({ text: $event })"
        />
        <ClientOnly>
            <Teleport
                v-if="layout.notificationBar"
                to="app-notification-bar-teleport-target"
            >
                <NotificationBar
                    :type="layout.notificationBar.type"
                    :icon-success="layout.notificationBar.iconSuccess"
                    :icon-info="layout.notificationBar.iconInfo"
                    :icon-error="layout.notificationBar.iconError"
                    :message="layout.notificationBar.message"
                    :link="layout.notificationBar.link"
                    :link-text="layout.notificationBar.linkText"
                    :visible="layout.notificationBar.visible"
                />
            </Teleport>
        </ClientOnly>

        <AppSnackbar />
        <slot />
        <ClientOnly>
            <Teleport
                to="#app-footer-teleport-target"
            >
                <TheFooter
                    modifier="default"
                    show-social-list
                />
            </Teleport>
        </ClientOnly>
    </div>
</template>

<style lang="scss">
@use "styles";
</style>
